import { createSlice } from '@reduxjs/toolkit';
import { Constants } from 'utilities/constants';

export const initialState = {
  [Constants.Module.UNDERWRITE]: {
    searchIsOpen: false,
    searchValue: '',
    searchBoxValue: '',
    data: [],
    resultsLimited: false,
    importCount: 0,
    propertyCount: 0,
    auctionCount: 0,
    loading: false,
    isSearchingLastPriced: false
  },
  [Constants.Module.POSTACQ]: {
    searchIsOpen: false,
    searchValue: '',
    searchBoxValue: '',
    data: [],
    resultsLimited: false,
    importCount: 0,
    propertyCount: 0,
    auctionCount: 0,
    loading: false,
    isSearchingLastPriced: false
  }
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    setSearchState: {
      reducer: (state, action) => { // Triggers searchResultFetchSaga
        const { module, newState } = action.payload;
        state[module] = {
          ...state[module],
          ...newState
        }
      },
      prepare: (module, newState) => ({ payload: { module, newState }})
    },
    
    // Redux saga actions, no reducers
    fetchSearch: { // Triggers searchResultFetchSaga
      reducer: () => { },
      prepare: (module, searchValue) => ({ payload: { module, searchValue }})
    },
    fetchSearchLastPricedByMe: () => { } // Triggers searchResultFetchSaga
  }
});

export default slice.reducer;

export const searchActions = slice.actions;

// Memoized selectors

